<div class="clear-both">
  <h3 [hidden]="noTitle" class="mt-lg"><span *ngIf="isAnyMandatory" class="ant-form-item-required"></span>{{title}}</h3>
  <nz-divider [hidden]="noTitle" class="mb-lg mt0 mob-mb-lg"></nz-divider>

  <ng-container *ngIf="!read || listWithUpload">
    <!-- <div nz-row>
      <div nz-col nzXl="12" nzLg="12" nzMd="24" nzSm="24" nzXs="24">
        <nz-form-item style="width:100%" class="pr-md">
          <nz-form-control [nzSpan]="20" nzValidateStatus="validating" style="width:100%">
            <nz-select id="docType" [(ngModel)]="docType" nzShowSearch nzAllowClear id="docTypetype"
              (ngModelChange)="onDocTypeChanges($event)">
              <nz-option nzCustomContent *ngFor="let type of fileTypes" [nzLabel]="type.fileName"
                [nzValue]="type.fileName">{{type.fileName}}
              </nz-option>
            </nz-select>
          </nz-form-control>
        </nz-form-item>
      </div>
    </div> -->

    <nz-spin [nzIndicator]="indicatorLoadingTemplate" [nzSpinning]="isSpinning">
      <div (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)" 
           [class.drag-over]="isDragOver">
        <nz-upload nzType="drag" [nzMultiple]="multiple" [nzShowUploadList]="nzShowUploadList"
          [nzCustomRequest]="customUploadReq" nzListType="picture" [nzFileList]="attachedFiles"
          [nzOpenFileDialogOnClick]="isUploadEnabled()" [nzDisabled]="disabled" [nzAccept]="fileTypes">
          <p class="ant-upload-drag-icon">
            <i nz-icon nzType="inbox" [ngStyle]="{ color: disabled ? '#bfbfbf' : '#1890ff' }"> </i>
          </p>
          <p class="ant-upload-text">Click or drag file to this area to upload</p>
          <p class="ant-upload-hint text-danger">
            Maximum file size is {{maxFileSizeMB}} mb. Support for a single or bulk upload. File types (XSLX/XLS/CSV/PDF/WORD/JPEG/JPG/PNG) are allowed.
          </p>
        </nz-upload>
      </div>
    </nz-spin>

    <nz-table [nzData]="attachedFiles" class="clear-both mt-lg" [nzShowPagination]="false"
      *ngIf="attachedFiles.length > 0 && isShowTable">
      <thead (nzSortChange)="sort($event)" nzSingleSort>
        <tr>
          <!-- <th nzShowSort nzSortKey="fileType" nzWidth="30%">Document Type</th> -->
          <th nzShowSort nzSortKey="originalFileName" nzWidth="30%">Name</th>
          <th nzShowSort nzSortKey="uploadedBy" nzWidth="22%">Uploaded By</th>
          <th nzShowSort nzSortKey="uploadedDate" nzWidth="22%">Uploaded Date</th>
          <th nzShowSort nzSortKey="status" nzWidth="10%">Status</th>
          <th nzWidth="8%">Action</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let data of attachedFiles">
          <td nzWidth="30%"> {{ data?.originalFileName || data?.fileName }}</td>
          <td nzWidth="30%">{{ data?.uploadedBy  }}</td>
          <td nzWidth="30%"> {{ data?.uploadedDate | date:'dd-MM-yyyy HH:mm' }}</td>
          <td nzWidth="30%">{{ data?.status }}</td>
          <td nzWidth="10%">
            <a nz-button nz-dropdown [nzDropdownMenu]="menu">
              <i nz-icon nzType="more" nzTheme="outline"></i>
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item *ngIf="data.status === 'Done'">
                  <a class="mr8" id="downloadAttachment" (click)="downloadAttachment(data)"><i nz-icon nzType="download"
                      nzTheme="outline"></i> {{'ums.um.download' | translate}}</a>
                </li>
                <li nz-menu-item>
                  <a id="deleteAttachment" (click)="deleteAttachment(data)" *ngIf="(!read)"><i nz-icon nzType="delete"
                      nzTheme="outline"></i> {{'ums.um.delete' | translate}}</a>
                </li>
                <li nz-menu-item *ngIf="data.fileUrl===undefined && (!read) && downloadEndpoint === '/bps'">
                  <a id="deleteInlineAttachment" (click)="deleteInlineAttachment(data)"><i nz-icon nzType="delete"
                      nzTheme="outline"></i> {{'app.label.remove' | translate}}</a>
                </li>
              </ul>
            </nz-dropdown-menu>

          </td>
        </tr>
      </tbody>
    </nz-table>

  </ng-container>

  <ng-container *ngIf="read ">
    <ng-container *ngTemplateOutlet="viewMode"></ng-container>
  </ng-container>

</div>

<ng-template #viewMode>
  <nz-table [nzData]="attachedFiles" class="clear-both mt-lg" [nzShowPagination]="false"
    *ngIf="attachedFiles.length > 0">
    <thead>
      <tr>
        <th nzWidth="30%">Document Type</th>
        <th nzWidth="30%">Name</th>
        <th nzWidth="30%">Type</th>
        <th nzWidth="10%"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let data of attachedFiles">
        <td nzWidth="30%">{{ data.docType || data.fileType }}</td>
        <td nzWidth="30%">{{ data.fileName }}</td>
        <td nzWidth="30%">{{ data.type }}</td>
        <td nzWidth="10%">
        <a class="mr8" id="downloadAttachment" (click)="downloadAttachment(data)"><i nz-icon nzType="download"
          nzTheme="outline"></i></a>
        </td>
      </tr>
    </tbody>
  </nz-table>
</ng-template>

<ng-template #indicatorLoadingTemplate>
  <img src="assets/img/uploadianimation.gif" alt="uploading...">
</ng-template>
